export function getClassify(roadArr) {
  console.log(roadArr)
  var waysList = roadArr.ways;
  var start = roadArr.startPoint;
  var end = roadArr.endPoint;
  var leftArr = [];
  var rightArr = [];
  var midArr = [];
  for(let i=0; i<waysList.length; i++) {
    var res = (start.lng - waysList[i].point.lng)*(end.lat - waysList[i].point.lat) - (start.lat - waysList[i].point.lat)*(end.lng - waysList[i].point.lng)/2;    
    if (res > 0) {
      leftArr.push(waysList[i])
    } else if (res < 0) {
      rightArr.push(waysList[i])
    } else {
      midArr.push(waysList[i])
    }
  }
  return {
    leftArr,
    rightArr,
    midArr
  }
}


export function getShortestPath(roadArr, waysArr) {
  // var result = [];
  // var copy_arr = roadArr.ways.slice();
  var copy_arr = waysArr.slice();
  copy_arr.unshift({ address: roadArr.startAddress, point: roadArr.startPoint })
  for (var k = 0; k < copy_arr.length; k++) {
    // 如果是最后一项，则不需要寻找最近点
    if (k == copy_arr.length - 1) {
      return false
    }
    // 起点（循环）
    var startX = copy_arr[k].point.lng;
    var startY = copy_arr[k].point.lat;
    // 终点
    var endX = roadArr.endPoint.lng - startX;
    var endY = roadArr.endPoint.lat - startY;
    // 求出旋转角度
    var rotate_a = endY / endX; // 转度数：rotate_a * 180 / 派
    var newArr = [];
    for (var i = k + 1; i < copy_arr.length; i++) {
      var item_x = copy_arr[i].point.lng - startX;
      var item_y = copy_arr[i].point.lat - startY;
      // 求点在旋转后，所在的 x 值（x 值越小越近）
      var newItem_x = Math.abs(rotate_a * item_x + rotate_a * item_y);
      // var newItem_y = rotate_a * item_y - rotate_a * item_x;
      newArr.push({ id: i, x: newItem_x })
    }
    // console.log(newArr)
    // 进行排序（index[0]为最近点）
    BubbleSort(newArr)
    // console.log(newArr[0].id) // 最近点
    // result.push(newArr[0].id)
    // 调整途径点数组的位置（近前远后）
    copy_arr = setArrFun(k, newArr[0].id, copy_arr)
    if (k == copy_arr.length - 2) {
      // console.log(copy_arr)
      // 返回前移除数组里起点的坐标
      copy_arr = copy_arr.slice(1, copy_arr.length)
      return copy_arr
    }
  }
  console.log(copy_arr)
}

// 改变途径点数组排序
function setArrFun(index, newIndex, copy_arr) {
  var road = copy_arr[newIndex]
  copy_arr[newIndex] = copy_arr[index + 1]
  copy_arr[index + 1] = road;
  // console.log(copy_arr)
  return copy_arr
}

// 数组排序算法
function BubbleSort(arr) {
  for (var i = 0; i < arr.length - 1; i++) {
    for (var j = 0; j < arr.length - i - 1; j++) {
      if (arr[j].x > arr[j + 1].x) {
        var tmp = arr[j];
        arr[j] = arr[j + 1];
        arr[j + 1] = tmp;
      }
    }
  }
}
